import * as angular from 'angular';

"use strict";
angular.module('ButtonsModule', []);

export default 'ButtonsModule';
